<template>
  <footer>
    <div class="foot-container">
      <div
        v-for="(item, index) in footList"
        :key="index"
        :class="{
          'foot-left': true,
          'last-foot-left': index === footList.length - 1
        }"
      >
        <h2 style="text-align: center">{{ item.title }}</h2>
        <ul>
          <!-- <li v-for="(sub_item, index) in item.subList" :key="index" > -->
          <li
            v-for="(sub_item, index) in item.subList"
            :key="index"
            @click="link(sub_item)"
            style="text-align:left;color:#969595"
          >
            <router-link :to="sub_item.link">{{
              sub_item.sub_title
            }}</router-link>
            <!-- <el-link type="primary" target="_blank">{{sub_item.sub_title}}</el-link> -->
          </li>
        </ul>
      </div>
      <div class="foot-middle">
        <h2 style="text-align: center">联系我们</h2>
        <ul>
          <li style="color: #FF8724;">
            <span style="float:left;margin-right: 8px;"
              ><i class="el-icon-location-outline"></i
            ></span>
            <div style="display: inline-block;">
              武汉佰港城橙果公寓-A座1713
            </div>
          </li>

          <!-- class="el-icon-printer" -->
          <li style="color: #67C23A;">
            <i class="el-icon-phone"></i> 电话：151-7249 7158
          </li>
          <!-- <li style="color: #009688;"> 传真：151-7249 7158</li> -->
          <li style="color: #009688;">
            <i class="el-icon-s-promotion"></i> 邮箱：xiaowenbo@nantu.vip
          </li>
        </ul>
      </div>
      <div class="foot-right QRcode">
        <h2>官网（移动端）</h2>
        <div id="qrcode" ref="qrcode">
          <!-- <img
          src="../assets/img/QRcode.png"
          alt="www.nantu.vip"
          width="100px"
          height="100px"
        /> -->
        </div>
        <div class="QRcode" style="margin-top: 20px;">
          <h2>抖音扫一扫</h2>
          <p style="margin-bottom:20px;font-size:14px;" class="QRcode_p">
            <a href="https://v.douyin.com/ienTXWbQ/" target="_blank">
              <img
                src="../assets/img/douying.png"
                alt="抖音二维码"
                width="100px"
                height="120px"
              />
            </a>
          </p>
          <h5>
            <a
              href="https://www.douyin.com/user/self?showTab=post"
              target="_blank"
              >抖音更精彩 >></a
            >
          </h5>
        </div>
      </div>
    </div>
    <div class="foot-bottom">
      <div>
        © Copyrights 2019~2099 武汉南图科技有限公司. All rights reserved
        <el-link type="primary" href="http://beian.miit.gov.cn" target="_blank"
          >备案/许可证编号：鄂ICP备2020018450</el-link
        >
      </div>
    </div>
  </footer>
</template>

<script>
// 需要在页面中引入
import QRCode from "qrcodejs2";

export default {
  name: "Footer",
  components: {
    QRCode
  },
  mounted() {
    this.qrcodeScan(); // 注：需在mounted里触发qrcodeScan函数
  },
  data() {
    return {
      footList: [
        {
          title: "实景三维案例",
          subList: [
            {
              sub_title: "三维路径规划与预警",
              link: "http://nantu.vip:8004"
            },
            {
              sub_title: "湖北蒋场风电",
              link: "http://nantu.vip:8181/tmjc/"
            },
            {
              sub_title: "南图三维基础项目",
              link: "http://nantu.vip:8181/jcxm/"
            },
            {
              sub_title: "地理时空应用系统",
              link: "http://nantu.vip:8181/CGis"
            },
            {
              sub_title: "南图全景应用展示",
              link: "http://nantu.vip:8181/pano"
            },
            {
              sub_title: "三维机房展示系统",
              link: "http://nantu.vip:8181/bi3d"
            }
          ]
        },
        {
          title: "商业智能案列",
          subList: [
            {
              sub_title: "省公路大屏展示",
              link: "http://nantu.vip:8181/bigscreenHB"
            },
            {
              sub_title: "智慧汉阳运营中心",
              link: "http://nantu.vip:8181/smartHanyang/"
            },
            {
              sub_title: "酷屏组件",
              link: "http://nantu.vip:8181/vueDataV/"
            },
            {
              sub_title: "数字房管",
              link: "http://nantu.vip:8181/wydashboard/"
            }
          ]
        },
        {
          title: "产品体系",
          subList: [
            {
              sub_title: "南图全景",
              link: "/software/panoVR"
            },
            {
              sub_title: "数字三维",
              link: ""
            },
            {
              sub_title: "智慧服务",
              link: ""
            }
          ]
        },
        {
          title: "战略合作",
          subList: [
            {
              sub_title: "地质大学信工学院",
              link: "http://xgxy.cug.edu.cn/"
            },
            {
              sub_title: "丰图科技(深圳)",
              link: "https://www.sf-tech.com.cn/"
            },
            {
              sub_title: "广州思迈特",
              link: "https://www.smartbi.com.cn/"
            },
            {
              sub_title: "探测者科技",
              link: "https://www.explore-tec.com/"
            },
            {
              sub_title: "湖北经济学院",
              link: "https://ysxy.hbue.edu.cn/"
            }
          ]
        }
      ]
    };
  },
  methods: {
    qrcodeScan() {
      //生成二维码
      let qrcode = new QRCode(this.$refs.qrcode, {
        width: 100, // 二维码宽度
        height: 100, // 二维码高度
        text: "http://nantu.vip/", // 需要二维码跳转的地址
        colorDark: "#70D0", //前景色
        colorLight: "white", //背景色
        correctLevel: QRCode.CorrectLevel.H //容错率
      });
      // console.log("二维码:", a);
      // qrcode.clear() //清除二维码

      // qrcode.makeCode('http://www.4399.com') //生成另一个新的二维码
    },
    route2() {
      this.$router.push("/home");
      this.active = "首页";
    },
    link(obj) {
      //alert(url);
      window.open(obj.link, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
footer {
  width: 100%;

  .foot-container {
    z-index: 1;
    background: #343434;
    width: 100%;
    padding: 3% 5%;
    margin-top: 20px;
    box-sizing: border-box;
    display: flex;

    h2 {
      color: #fff;
      margin: 0 -22px 15px -19px;
      font-size: 16px;
      font-family: "Open Sans", sans-serif;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    ul {
      li {
        padding: 5px;
        padding-left: 0;
        padding-right: 0;
        color: #969595;
        font-size: 14px;
      }
    }

    .foot-left {
      margin-right: 6%;

      ul {
        li {
          padding: 10px;
          border-top: 1px solid #3f3f3f;
          margin: 0 -22px 0px -19px;

          a {
            color: #969595;
            /* 默认文字颜色 */
            display: block;
            font-size: 14px;
            text-decoration: none;
            position: relative;
            transition: all 0.3s;

            &:hover {
              color: #ff8724;
              transform: scale(1.2);
            }

            &:before {
              content: "";
              position: absolute;
              bottom: -2px;
              left: 0;
              width: 100%;
              height: 0.5px;
              /* 调整下划线的高度，使它更薄 */
              background-color: #0875ea;
              /* 设置下划线颜色为蓝色 */
              opacity: 0;
              transition: opacity 0.3s;
            }

            &:hover:before {
              opacity: 1;
            }
          }
        }
      }
    }

    .last-foot-left {
      margin-right: 2%;
    }

    .foot-middle {
      width: 24%;
      /* 设置宽度为 20% 或其他你想要的宽度 */
      margin-left: 3%;
      position: relative;
      text-align: left;

      &::before {
        position: absolute;
        content: "";
        height: 80%;
        width: 1px;
        background-color: #3f3f3f;
        left: -30px;
        top: 10%;
      }

      ul > li > i {
        margin-right: 8px;
      }
    }

    .foot-right {
      text-align: left;
      margin-left: 5%;

      ul {
        display: grid;
        grid-template-columns: repeat(4, 25%);
        grid-template-rows: repeat(2, 42%);
        gap: 3px;

        li:hover {
          animation: pulse 0.5s linear;
        }
      }

      h5 {
        text-align: right;
      }
    }
  }

  .foot-bottom {
    background: #2f2f2f;
    padding: 15px 0;
    box-sizing: border-box;
    width: 100%;
    color: #969595;
    font-size: 14px;
    display: flex;
    justify-content: space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue